import authorization from '@/store/authorization/authorization'
import companyAdmins from '@/store/authorization/companyAdmins'
export default { authorization, companyAdmins }
